import { combineEpics, ofType } from "redux-observable";
import { concatMap, from, map, mergeMap, of, withLatestFrom } from "rxjs";
import { RootState } from "../../../store/ConfigureStore";
import { loadEquipments, loadOilContraction, loadProtectorCalculations, loadProtectorList, loadProtectorSeries } from "../../../services/calculations/calculation-output/protector.service";
import { setBearingType, setLowerEqupimentList, setOilContractionList, setOilType, setProtectorCalculationComplete, setProtectorCalculations, setProtectorList, setProtectorListSeries, setSelectedLowerProtector, setSelectedUpperProtector, setShaftPercentage, setShaftRatingValue, setshaftType, setThrustPercentage, setUpperEqupimentList } from "../../../store/calculation/calculation-output/protectorSlice";
import { setDummy, setHiddenProtector1, setHiddenProtector2, setHiddenProtectorOilType } from "../../../store/calculation/calculation-input/TubingSlice";


const fetchProtectorSeries = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "gasCalculation/gasCalculationStart",
            "motor/setMotorInput",
            "motor/setMotorCalculationComplete",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
        ),
        concatMap(([actionData, protector]) => {
            var casingOD = protector?.casingOD;
            return from(loadProtectorSeries(casingOD)).pipe(
                mergeMap(data => {
                    return [
                        setProtectorListSeries(data?.protSeriesList),
                        setOilType(data?.mtrOilTypesList),
                        setBearingType(data?.protBearngTypeList),
                        setshaftType(data?.protShaftTypeList),
                    ]
                }),
            )
        }),
    )
};

const selectMotorOilType = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "protector/setOilType",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.protector?.oilType)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
        ),
        map(([actionData, oilType, tab1Input]) => {
            if (oilType && !tab1Input?.hdnProtector_OilType) {
                return setHiddenProtectorOilType(Object.values(oilType)[0])
            }
            return { type: "" };
        }),
    )
};


const fetchProtectorList = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setCatalogType",
            "gasCalculation/gasCalculationStart",
            "motor/setMotorInput",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
        ),
        concatMap(([actionData, tab1Input]) => {
            const payload = {
                casingOD: tab1Input?.casingOD?.toString(),
                UnitSytm: tab1Input?.unitSys?.toString(),
                MotrSers: tab1Input?.hiddenProtSers?.toString() || "",
                catalogFilter: +tab1Input?.catalogType
            }
            return from(loadProtectorList(payload)).pipe(
                map(data => {
                    return setProtectorList(data)
                }),
            )
        }),
    )
};

const fetchOilContraction = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "motor/setMotorCalculationComplete",
            "motor/setMotorLoadInput",
            "tubing/setHiddenProtector1",
            "tubing/setHiddenProtector2",
            "tubing/setHiddenProtectorOilType",
            // "gasCalculation/setGasCalculationStart",
            "protector/setOilType",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.protector?.selectedLowerProtector)),
            state$.pipe(map((state: RootState) => state?.protector?.selectedUpperProtector)),
            state$.pipe(map((state: RootState) => state?.motor)),
            state$.pipe(map((state: RootState) => state?.motor?.MotorCalculationComplete)),
            state$.pipe(map((state: RootState) => state?.motor?.SelectedMotor)),
        ),
        concatMap(([actionData, tab1Input, tab3Input, selectedLowerProtector, selectedUpperProtector, MotorInput, MotorCalculationComplete, SelectedMotor]) => {
            let payload: (string | number)[] = [];
            if (MotorCalculationComplete) {
                if (tab1Input?.hdnProtector_Protector1 !== "" || tab1Input?.hdnProtector_Protector2 !== "") {
                    const bottmWhole = tab3Input?.bottomHoleTemp || ""
                    const mtrTemp = SelectedMotor?.maxOperatingTemp ?? ''
                    const mtrHP = SelectedMotor?.baseHP ?? ''
                    const mtrOilTy = tab1Input?.hdnProtector_OilType?.toString() == "" ? 0 : tab1Input?.hdnProtector_OilType || 0
                    const mtrSers = SelectedMotor?.series;
                    const prtLwr = tab1Input?.hdnProtector_Protector1?.protectorID || tab1Input?.hdnProtector_Protector1 || ""
                    const prtUpr = tab1Input?.hdnProtector_Protector2?.protectorID || tab1Input?.hdnProtector_Protector2 || ""
                    let protSrs;
                    if (prtLwr == "") protSrs = selectedUpperProtector?.series || ""
                    else protSrs = selectedLowerProtector?.series || ""
                    const surfTemp = tab3Input?.surfaceTemperature || ""
                    const bottmWholeUnit = tab3Input?.unitBottomHoleTempListVal || ""
                    const surfTempUnit = tab3Input?.unitSurfaceTemperatureListVal || ""
                    const motrHPUnit = tab1Input?.hdnUnitMotor_TPower || ""
                    const mtrID = tab1Input?.hiddenMotrID || ""
                    const hpReq = MotorInput?.motor_HPInput?.toString() || 0
                    const opFreq = tab3Input?.operatngFreq || ""
                    const unitSys = tab1Input?.unitSys || ""
                    const OpTempUnit = tab1Input?.hdnUnitMotor_T1OperatingTemp || ""
                    const motorLoad = MotorInput?.MotorInput?.motorLoad;

                    payload = [bottmWhole, mtrTemp, mtrHP, mtrOilTy, mtrSers, prtLwr, protSrs, prtUpr, surfTemp, bottmWholeUnit, surfTempUnit, motrHPUnit, mtrID, hpReq, opFreq, unitSys, OpTempUnit, motorLoad];

                    return from(loadOilContraction(payload)).pipe(
                        map(data => {
                            return setOilContractionList(data)
                        }),
                    )
                }
            }
            return of({ type: "" });
        })
    )
};


const fetchProtectorCalculations = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "pump/setPumpCalculationComplete",
            "tubing/setHiddenProtectorBearingType",
            "tubing/setHiddenProtector1",
            "protector/setSelectedLowerProtector"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.pump?.PumpPressureShaft)),
            state$.pipe(map((state: RootState) => state?.pump?.SelectedPump)),
            state$.pipe(map((state: RootState) => state?.protector?.selectedLowerProtector)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasFinalCalculatedData)),
            state$.pipe(map((state: RootState) => state?.pump?.PumpInput)),
            state$.pipe(map((state: RootState) => state?.pump?.PumpCalculationComplete)),
        ),
        concatMap(([actionData, tab1Input, pumpPressureShaft, selectedPump, lowerProtractor, gasInput, tdhData, PumpInput, PumpCalculationComplete]) => {
            if (PumpCalculationComplete && selectedPump?.pumpID) {
                const pMax = pumpPressureShaft?.Pmax ?? '';
                const shaftDia = selectedPump?.shaftDiameter || '';
                const ID = lowerProtractor?.protectorID || '';
                const bearngTyp = tab1Input?.hdnProtector_BearingType ? tab1Input?.hdnProtector_BearingType?.toString() : "0";
                const unitSys = tab1Input?.unitSys?.toString();
                const pmpID = selectedPump?.pumpID;
                let noOfStages = gasInput?.noOfGasSeps;

                if (PumpInput?.pump_DesrdStges != null && PumpInput?.pump_DesrdStges != 0) {
                    noOfStages = PumpInput?.pump_DesrdStges?.toString();
                }

                const liqPhseDens = tdhData?.LiquidPhaseDensity?.toString();
                const shaftType = tab1Input?.hdnProtector_ShaftType?.toString() || '0';
                const liqPhseDensUnit = tab1Input?.hdnUnitLiqPhseDens;

                const payload = [pMax, shaftDia, ID, bearngTyp, unitSys, pmpID, noOfStages, liqPhseDens, shaftType, liqPhseDensUnit]

                return from(loadProtectorCalculations(payload)).pipe(
                    mergeMap(data => {
                        return [
                            setProtectorCalculations(data),
                            setProtectorCalculationComplete(true)
                        ]
                    }),
                );
            }
            return [setProtectorCalculationComplete(true)];
        }),
    )
};

const fetchSelectedProtector = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "protector/fetchSelectedProtector",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
        ),
        map(([actionData, tab1Input]) => {
            const lowerProtractorId: string = tab1Input?.hdnProtector_Protector1 ?? ''
            const upperProtractorId: string = tab1Input?.hdnProtector_Protector2 ?? ''

            if (upperProtractorId != '' && lowerProtractorId != '') {
                return setDummy()
            }
            if (upperProtractorId === '' && lowerProtractorId === '') {
                return setHiddenProtector1(actionData.payload?.protectorID)
            }
            else if (upperProtractorId !== '') {
                return setHiddenProtector1(actionData.payload?.protectorID)
            }
            else if (lowerProtractorId !== '') {
                return setHiddenProtector2(actionData.payload?.protectorID)
            }
            return setDummy()
        }),
    )
};

const fetchLowerEquipments = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setHiddenProtector1",
            "protector/setSelectedLowerProtector"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
        ),
        concatMap(([actionData, tab1Input]) => {
            return from(loadEquipments(tab1Input?.hdnCatalogFilter)).pipe(
                map(data => {
                    return setLowerEqupimentList(data)
                }),
            )
        }),
    )
};

const fetchUpperEquipments = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setHiddenProtector2",
            "protector/setSelectedUpperProtector"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
        ),
        concatMap(([actionData, tab1Input]) => {
            return from(loadEquipments(tab1Input?.hdnCatalogFilter)).pipe(
                map(data => {
                    return setUpperEqupimentList(data)
                }),
            )
        }),
    )
};

const fetchProtectorPercentage = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "protector/loadProtectorPercentage",
            "protector/loadProtectorCalculations",
            "protector/setProtectorCalculations",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.protector?.protectorCalculations)),
        ),
        map(([actionData, protractorLoadCheck]) => {
            var force = (parseFloat(protractorLoadCheck?.[0] ?? '0'));
            var thrust = (parseFloat(protractorLoadCheck?.[1] ?? '0'));
            let prCntThrust: string = "0";
            if (thrust != 0) {
                prCntThrust = ((force / thrust) * 100).toFixed(2);
            }
            return setThrustPercentage(prCntThrust || 0);
        })
    )
};

const GetSelectedUpperProtractor = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setHiddenProtector2",
            "protector/fetchSelectedUpperProtector",
            "protector/setProtectorList",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.protector?.ProtectorList)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input?.operatngFreq)),
        ),
        map(([actionData, ProtectorList, tab1Input, opFreq]) => {
            let protector: any = {};
            if (ProtectorList?.length > 0) {

                const selectedProtractor2 = ProtectorList.find(
                    (x: any) => x.protectorID === tab1Input?.hdnProtector_Protector2,
                );

                if (selectedProtractor2) {
                    const stdval2 = ((selectedProtractor2.stdShaftHP * (opFreq)) / 60).toFixed(1);
                    const HSVal2 = ((selectedProtractor2.hsShaftHP * (opFreq)) / 60).toFixed(1);

                    protector = { ...selectedProtractor2, stdShaftHP: +stdval2, hsShaftHP: +HSVal2 }
                }
                return setSelectedUpperProtector(protector)
            }
            return { type: "" }
        })
    )
};


const GetSelectedLowerProtractor = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setHiddenProtector1",
            "protector/fetchSelectedLowerProtector",
            "protector/setProtectorList",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.protector?.ProtectorList)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input?.operatngFreq)),
        ),
        map(([actionData, ProtectorList, tab1Input, opFreq]) => {
            let protector: any = {};
            if (ProtectorList?.length > 0) {

                const selectedProtractor2 = ProtectorList.find(
                    (x: any) => x.protectorID === tab1Input?.hdnProtector_Protector1,
                );

                if (selectedProtractor2) {
                    const stdval2 = ((selectedProtractor2.stdShaftHP * (opFreq)) / 60).toFixed(1);
                    const HSVal2 = ((selectedProtractor2.hsShaftHP * (opFreq)) / 60).toFixed(1);

                    protector = { ...selectedProtractor2, stdShaftHP: +stdval2, hsShaftHP: +HSVal2 }
                }
                return setSelectedLowerProtector(protector)
            }
            return { type: "" }
        })
    )
};


const GetProtractorShaftRating = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setHiddenProtector1",
            "protector/setProtectorCalculations",
            "protector/setSelectedLowerProtector",
            "tubing/setHiddenProtectorShaftType"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input?.operatngFreq)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.protector?.ProtectorList)),
        ),
        map(([actionData, opFreq, tab1Input, ProtectorList]) => {
            if (ProtectorList?.length > 0) {
                const selectedProtractor2 = ProtectorList?.find(
                    (x: any) => x.protectorID === tab1Input?.hdnProtector_Protector1,
                );

                const shaftRating = tab1Input?.hdnProtector_ShaftType == 0 ? selectedProtractor2?.stdShaftHP : selectedProtractor2?.hsShaftHP

                if (shaftRating) {
                    const shaftRatingValue = ((shaftRating * (opFreq)) / 60).toFixed(1);
                    return setShaftRatingValue(shaftRatingValue)
                }
            }
            return { type: "" }
        })
    )
};

const GetPercentageShaftRating = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setHiddenProtector1",
            "protector/loadProtectorPercentage",
            "protector/loadProtectorCalculations",
            "protector/setProtectorCalculations",
            "protector/setShaftRatingValue"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.protector?.shaftRatingValue)),
            state$.pipe(map((state: RootState) => state?.motor)),
        ),
        map(([actionData, ProtractorShaft, MotorInput]) => {
            var ProtractorShaftRating = parseFloat(ProtractorShaft);
            var MotorInput_HP = parseFloat(MotorInput?.motor_HPInput);
            if (ProtractorShaftRating != 0) {
                var percentage = ((MotorInput_HP / ProtractorShaftRating) * 100).toFixed(0);
                return setShaftPercentage(percentage);
            }
            return { type: "" }
        })
    )
};


export const gasProtectorEpic = combineEpics(
    fetchProtectorSeries,
    fetchOilContraction,
    fetchProtectorList,
    fetchProtectorCalculations,
    fetchSelectedProtector,
    fetchLowerEquipments,
    fetchUpperEquipments,
    fetchProtectorPercentage,
    GetSelectedUpperProtractor,
    GetSelectedLowerProtractor,
    selectMotorOilType,
    GetProtractorShaftRating,
    GetPercentageShaftRating
);
